import { createFileRoute, redirect } from '@tanstack/react-router'
import { useNavigate } from '@tanstack/react-router'
import TemplateSelectionPage from '@/features/city-clerk/admin-report/pages/TemplateSelectionPage/TemplateSelectionPage'
import { useNavigation } from '@/utils/navigation'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.adminReportView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const {
    id: cityId,
    projectId,
    permitId,
    permitSubmitalId,
  } = Route.useParams()
  const navigate = useNavigate()
  const nav = useNavigation(navigate)

  function onSelectTemplate(templateKey: string) {
    nav.toAdminReportBuilder(
      cityId,
      projectId,
      permitId,
      permitSubmitalId,
      templateKey,
    )
  }

  return (
    <TemplateSelectionPage
      cityId={cityId}
      projectId={projectId}
      permitId={permitId}
      permitSubmitalId={permitSubmitalId}
      onSelectTemplate={onSelectTemplate}
      type="admin-check"
    />
  )
}
